import { Historia } from '../../data/types/historia.types'
import { formatStringToUserFullDate } from '../../helpers/dates.helper'

const cardStyle: React.CSSProperties = {
	border: '1px solid #e2e8f0',
	borderRadius: '8px',
	padding: '16px',
	marginBottom: '16px',
	boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: '#ffffff',
}

export const HistoriaCard = ({ historia }: { historia: Historia }) => {
	return (
		<div style={cardStyle}>
			<h3>{`${formatStringToUserFullDate(historia.fecha)} - ${historia.medicoNombre} `}</h3>
			<p>{historia.notas}</p>
		</div>
	)
}